import React from 'react'
import styled from 'styled-components'
import LogoLI from '../../../assets/LOGIC-IMMO_RVB.svg'

const StyledBanner = styled.div`
  position: relative;
  box-shadow: 0 1px 4px 0 rgba(0, 0, 0, 0.2);
  display: flex;
  align-items: center;
  padding: 0rem 1rem;
  height: 70px;

  img {
    height: 45px;
    vertical-align: middle;
  }

  @media screen and (max-width: 1024px) {
    padding: 1rem;
    img {
      height: 30px;
    }
  }
`

const BannerLi = () => (
  <StyledBanner>
    <a href="https://www.logic-immo.com/" title="Logic-Immo">
      <img src={LogoLI} alt="Logic-immo" />
    </a>
  </StyledBanner>
)

export default BannerLi
